import { PageData } from '../../../../_metronic/helpers/utils/types';
import { getIdealImageSize } from '../../../../_metronic/helpers/utils/utils';

export const navbarData: PageData = [
  {
    formId: 'form1',
    heading: 'Navbar Section',
    data: [
      {
        id: 'logo',
        label: 'Company logo',
        info: getIdealImageSize(156, 42),
        type: 'image',
        backgroundColor: '#000'
      },
      { id: 'languageButtonText', label: 'Text for language button', type: 'input' },
      { id: 'signUpButtonText', label: 'Sign up button text', type: 'input' },
      { id: 'signUpButtonLink', label: 'Sign up button link', type: 'input' },
      { id: 'loginButtonText', label: 'Login button text', type: 'input' },
      { id: 'loginButtonLink', label: 'Login button link', type: 'input' }
    ]
  },
  {
    formId: 'formGroup1',
    heading: 'Navbar links',
    data: [
      { id: 'navText', label: 'Navbar link text', type: 'input' },
      { id: 'navLink', label: 'Navbar link URL', type: 'input' }
    ]
  }
];
